import '@/index.css';
import '@blueprintjs/core/lib/css/blueprint.css';
import '@blueprintjs/select/lib/css/blueprint-select.css';
import '@blueprintjs/icons/lib/css/blueprint-icons.css';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { BlueprintProvider, Classes, FocusStyleManager } from '@blueprintjs/core';

import { installDiagnosticCapture } from '@/diagnostics/browserDiagnostics';
import { App } from '@/App';
import { registerOfflineApp } from '@/pwa/offline';

registerOfflineApp();
installDiagnosticCapture();

// Initialize once at client startup, outside React's StrictMode lifecycle.
if (!FocusStyleManager.isActive()) {
  FocusStyleManager.onlyShowFocusOnTabs();
  // Canvas controls cancel pointerdown's compatibility mousedown; menus stop Tab
  // bubbling. Keep Blueprint's styling class in sync before either is handled.
  const container = document.documentElement;
  container.addEventListener(
    'pointerdown',
    () => container.classList.add(Classes.FOCUS_DISABLED),
    true,
  );
  container.addEventListener(
    'keydown',
    (event) => {
      if (event.key === 'Tab') container.classList.remove(Classes.FOCUS_DISABLED);
    },
    true,
  );
}

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('No root element found');
const root = createRoot(rootElement);
root.render(
  <React.StrictMode>
    <BlueprintProvider>
      <App />
    </BlueprintProvider>
  </React.StrictMode>,
);
